import { render, staticRenderFns } from "./DummyColumns.vue?vue&type=template&id=53c5ed20&scoped=true&"
import script from "./DummyColumns.vue?vue&type=script&lang=js&"
export * from "./DummyColumns.vue?vue&type=script&lang=js&"
import style0 from "./DummyColumns.vue?vue&type=style&index=0&id=53c5ed20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c5ed20",
  null
  
)

export default component.exports